import React from 'react';
import Typo from '../Typography/Typo';
import { DangerIcon } from '../Icons/DangerIcon';

export const ArticleParentQuoteInfoRemoved = () => (
  <div className="relative mt-4 flex gap-1 items-center stroke-t2-error-darkRed">
    <div className="absolute -top-[2px] left-0">
      <DangerIcon />
    </div>
    <Typo variant="small-p" className="ml-8 !text-sm text-t2-error-darkRed">
      This post has been removed or deleted
    </Typo>
  </div>
);
